import { useState } from 'react';
import { RuleApiModel, SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { P2GLink } from '@parcel2go/core-ui';
import CreateRuleOptions from './CreateRuleOptions';
import RuleCreatePrompt from './RuleCreatePrompt';
import { P2GBox } from '@parcel2go/core-ui';
import { P2GText } from '@parcel2go/core-ui';
import { P2GLinkGroup } from '@parcel2go/core-ui';

interface props {
  item: SmartSendItemApiModel;
  actions: string[];
  rule?: RuleApiModel;
  addNewRule: (conditions: string[], title: string, description: string) => void;
  updateExistingRule: (rule: RuleApiModel, conditions: string[], title: string, description: string) => void;
  onSelection: (open: boolean) => void;
  showRuleName: boolean;
}

export default function RuleItem(props: props) {
  const [showRuleCreateDialog, setShowRuleCreateDialog] = useState(false);

  const addRule = (conditions: string[], title: string, description: string) => {
    props.addNewRule(conditions, title, description);
    setShowRuleCreateDialog(false);
  };

  const updateExistingRule = (rule: RuleApiModel, conditions: string[], title: string, description: string) => {
    props.updateExistingRule(rule, conditions, title, description);
    setShowRuleCreateDialog(false);
  };

  const onSelection = (open: boolean) => {
    setShowRuleCreateDialog(open);
    props.onSelection(open);
  };

  return (
    <P2GBox p={showRuleCreateDialog ? 0 : 1} bordered={!showRuleCreateDialog}>
      {props.showRuleName && (
        <P2GBox mb={1}>
          <P2GText variant="body2">
            <strong>{props.rule?.Name}</strong>
          </P2GText>
        </P2GBox>
      )}

      <RuleCreatePrompt
        item={props.item}
        actions={props.actions}
        link={
          <P2GLinkGroup
            links={[
              !showRuleCreateDialog && (
                <P2GLink variant="body2" onClick={() => onSelection(!showRuleCreateDialog)}>
                  {props.rule ? 'Update' : 'Add'}
                </P2GLink>
              ),
              props.rule && (
                <P2GLink
                  variant="body2"
                  onClick={() => props.updateExistingRule(props.rule, [], props.rule.Name, props.rule.Description)}
                >
                  Remove
                </P2GLink>
              )
            ]}
          />
        }
      />

      {showRuleCreateDialog && (
        <CreateRuleOptions
          rule={props.rule}
          actions={props.actions}
          cancel={() => onSelection(false)}
          addRule={addRule}
          updateExistingRule={updateExistingRule}
          item={props.item}
        />
      )}
    </P2GBox>
  );
}
